import * as React from "react";
import styled from "styled-components";
const Row = styled.tr`
  cursor: default;
`;
const TD = styled.td`
  min-width: 50px;
  word-break: break-word;
  padding: 4px 5px 2px;
`;
const Content = styled.div`
  display: flex;
  align-items: flex-start;
`;
const EntityTableOverrideRow = ({ visibleCellCount, notice, actionCell = void 0 }) => /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(TD, { colSpan: Math.max(visibleCellCount - (actionCell ? 1 : 0), 1) }, /* @__PURE__ */ React.createElement(Content, null, notice)), actionCell);
export default EntityTableOverrideRow;
